import React from 'react';
import { useTranslation } from 'react-i18next';

interface DetailFieldProps {
    label: string;
    value: string | number | null | undefined;
    emptyLabel?: 'missing' | 'na';
    hide?: boolean;
    children?: React.ReactNode;
}

const DetailField: React.FC<DetailFieldProps> = ({
    label,
    value,
    emptyLabel = 'missing',
    hide = false,
    children,
}) => {
    const { t } = useTranslation();

    if (hide) return null;

    const isEmpty = value === null || value === undefined || value === '';
    const emptyText = emptyLabel === 'missing'
        ? t('asset_detail.missing')
        : t('asset_detail.not_applicable');

    return (
        <div className={'flex flex-col gap-0.5'}>
            <span className={'text-sm text-foreground/60 font-medium'}>{label}</span>
            {children ? (
                children
            ) : isEmpty ? (
                <span className={'text-sm text-foreground/40 italic'}>{emptyText}</span>
            ) : (
                <span className={'text-sm text-foreground'}>{value}</span>
            )}
        </div>
    );
};

export default DetailField;
